import http from "@/common/http-common";
import store from "@/store";

class AssetSubTypeService {
  async loadAll() {
    return http().get("/api/v1/asset_sub_types.json").then(function(resp) {
      console.log("Inside AssetSubTypeService.loadAll, resp.data ==> ", resp.data);
      store.commit("updateAssetSubTypes", resp.data);
    })

  }
}

export default new AssetSubTypeService();